import { render, staticRenderFns } from "./ManageRingingGroups.vue?vue&type=template&id=557aaaa9&scoped=true&"
import script from "./ManageRingingGroups.vue?vue&type=script&lang=js&"
export * from "./ManageRingingGroups.vue?vue&type=script&lang=js&"
import style0 from "./ManageRingingGroups.vue?vue&type=style&index=0&id=557aaaa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557aaaa9",
  null
  
)

export default component.exports